<div class="AmInputForm" [formGroup]="formGroup">
  <div class="AmInputForm-label fs-22px">
      {{ label | translate }}
  </div>
  <div class="AmInputForm-content-input" >
      <input
          [formControl]="textControlDay"
          [placeholder]="placeholderDay | translate"
          [formControlName]="nameInputDay"
          [id]="nameInputDay"
          [currentFormGroup]="formGroup"
          [isFloat]="false"
          appAmKeyboard
          autocomplete="off"
          class="form-control"
          readonly
          maxlength="2"
          [ngClass]="{
              'input--error': (textControlDay.touched && textControlDay.invalid)
          }"
          [type]="'number'"
          [showNav]="true"
          (ngModelChange)="onChangeDate(inputDay,inputMonth,2)"
          [readOnly]= "readOnly"
          #inputDay
      >
      <input
          [formControl]="textControlMonth"
          [placeholder]="placeholderMonth | translate"
          [formControlName]="nameInputMonth"
          [id]="nameInputMonth"
          [currentFormGroup]="formGroup"
          [isFloat]="false"
          appAmKeyboard
          autocomplete="off"
          class="form-control"
          readonly
          maxlength="2"
          [ngClass]="{
              'input--error': (textControlMonth.touched && textControlMonth.invalid)
          }"
          [type]="'number'"
          [showNav]="true"
          (ngModelChange)="onChangeDate(inputMonth,inputYear,2)"
          [readOnly]= "readOnly"
          #inputMonth
      >
      <input
          [formControl]="textControlYear"
          [placeholder]="placeholderYear | translate"
          [formControlName]="nameInputYear"
          [id]="nameInputYear"
          [currentFormGroup]="formGroup"
          [isFloat]="false"
          appAmKeyboard
          autocomplete="off"
          class="form-control"
          readonly
          maxlength="4"
          [ngClass]="{
              'input--error': (textControlYear.touched && textControlYear.invalid)
          }"
          [type]="'number'"
          [showNav]="true"
          (ngModelChange)="onChangeDate()"
          [readOnly]= "readOnly"
          #inputYear
      >
  </div>
  <app-icon-form-correct
      className="AmInputForm-formCorrect"
      [fieldInput]="textControlDate"
      [typeDate]="typeDate"
  ></app-icon-form-correct>
  <app-form-error-message style="width: 24%;"
      [fieldInput]="textControlDate"
      [errorRequired]="errorRequired"
      [errorPattern]="errorPattern"
  ></app-form-error-message>
</div>
